import React, { useEffect, useState } from 'react';
import {
  Switch,
  Route,
  withRouter,
} from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Menu } from 'antd';
import { SpTab } from 'components/DesignKit';

import InvoiceList from '../Invoices';
import ProductList from '../Products';

type Props = {
  location: {
    pathname: string
  },
};

const InvoiceRoutes = (props: Props) => {
  const {
    location,
  } = props;
  const [current, setCurrent] = useState('invoices');
  const { selectedAccount } = useSelector(state => state.account);

  const setMenu = (query) => {
    switch (query) {
      case '/invoices': {
        setCurrent('invoices');
        break;
      }
      case '/products': {
        setCurrent('products');
        break;
      }
      default:
        setCurrent('invoices');
    }
  };

  useEffect(() => {
    setMenu(location.pathname);
  }, [location]);

  return (
    <div>
      <Menu onClick={e => setCurrent(e.key)} selectedKeys={[current]} mode="horizontal" style={{ fontSize: '20px' }}>
        <Menu.Item key="invoices">
          <SpTab
            to="/invoices"
            selected={current === 'invoices'}
          >
            Invoices
          </SpTab>
        </Menu.Item>
        {
          selectedAccount?.legacySubscription && (
            <Menu.Item key="products">
              <SpTab
                to="/products"
                selected={current === 'products'}
              >
                Products
              </SpTab>
            </Menu.Item>
          )
        }
      </Menu>
      <Switch>
        <Route exact path="/invoices" component={InvoiceList} />
        <Route exact path="/products" component={ProductList} />
      </Switch>
    </div>
  );
};

export default withRouter(InvoiceRoutes);
